// Point d'entrée de l'application : injecte les styles puis branche les events.

import "./ui/styles.css";
import { bootstrap } from "./ui/form.js";

bootstrap();
